import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const SSIS = () => {
  return (
    <StartInterviewLayout type="ssis"/>
  )
}

export default SSIS;